export const RuleRegistryPlace = {
  surveyParticipants: "surveys.participants_rules",
  surveyShareEmployees: "surveys.share_employee_rules",
  timeOffPolicyAssignTo: "time_off_policies_versions.assign_to",
  performanceReviewParticipants: "performance_reviews_reviews.participants_rules",
  approvalPolicyAssignTo: "approval_policies.assign_to",
  approvalPolicyFlowRules: "approval_policies.flow_rules",
  approvalPolicySubstitutionRule: "approval_policies.substitution_rule",
  blogChannelView: "blog_channels.view_apply_to",
  blogChannelPublish: "blog_channels.publish_apply_to",
  documentFolderView: "folders.view_documents_rules",
  documentFolderEdit: "folders.edit_documents_rules",
  workflowSurveyParticipants: "workflow_block_action_surveys.participants_rules",
  workflowSurveyShareEmployees: "workflow_block_action_surveys.share_employee_rules",
  workflowPerformanceReviewParticipants:
    "workflow_block_action_performance_reviews.participants_rules",
  workflowPerformanceReviewReviewers: "workflow_block_action_pr_reviewer_types.participants_rules",
  workflowPerformanceReviewEnrollReviewers:
    "workflow_block_action_pr_enroll_reviewer_types.participants_rules",
  roleAssignTo: "roles_permissions.assign_to",
  roleApplyTo: "roles_permissions.apply_to",
  workflowTaskAssignTo: "workflow_block_action_tasks.assign_to_rules",
  workflowTaskWatchers: "workflow_block_action_tasks.watcher_rules",
  workflowMeetingAttendees: "workflow_block_action_meetings.attendee_rules",
  eventAttendees: "events.attendee_rules",
  esignRecipients: "esign_envelopes.recipient_rules",
  recognitionGiftRecipients: "employee_recognitions.recipient_rules",
  recognitionCategoryGift: "recognition_categories.gift_apply_to",
} as const;

export type RuleRegistryPlaceKey = (typeof RuleRegistryPlace)[keyof typeof RuleRegistryPlace];
